"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAttraction = exports.getAttraction = exports.addAttraction = exports.getAttractions = void 0;
const _ = require("lodash");
const getAttractions = async (supabase) => {
    const { data: attractions, error } = await supabase
        .from("attractions")
        .select(`*, region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .order("name", { ascending: true });
    if (!error)
        return attractions.map((attraction) => ({
            id: attraction.id,
            name: attraction.name,
            type: attraction.type,
            region: {
                id: attraction.region.id,
                name: attraction.region.name,
                slug: attraction.region.slug,
            },
            country: {
                id: attraction.region.country.id,
                name: attraction.region.country.name,
                slug: attraction.region.country.slug,
            },
        }));
    return error;
};
exports.getAttractions = getAttractions;
const addAttraction = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("attractions")
        .insert([obj])
        .select();
    if (!error)
        return data;
    return error;
};
exports.addAttraction = addAttraction;
const getAttraction = async (supabase, id) => {
    const { data: attraction, error } = await supabase
        .from("attractions")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return attraction;
    return error;
};
exports.getAttraction = getAttraction;
const updateAttraction = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("attractions")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateAttraction = updateAttraction;
